/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export const ChangePrescriptionRequestBodyResourceScope = {
  All: "all",
  Selected: "selected",
} as const;
export type ChangePrescriptionRequestBodyResourceScope = ClosedEnum<
  typeof ChangePrescriptionRequestBodyResourceScope
>;

export const ChangePrescriptionRequestBodyStartMode = {
  Now: "now",
  At: "at",
} as const;
export type ChangePrescriptionRequestBodyStartMode = ClosedEnum<
  typeof ChangePrescriptionRequestBodyStartMode
>;

export type ChangePrescriptionRequestBody = {
  expectedVersion: number;
  expiresAt?: Date | undefined;
  externalNote: string;
  internalNote: string;
  operationId: string;
  organizationId: string;
  prescriptionId: string;
  resourceScope: ChangePrescriptionRequestBodyResourceScope;
  selectedResourceInputs?: Array<string> | undefined;
  startMode: ChangePrescriptionRequestBodyStartMode;
  startsAt?: Date | undefined;
};

/** @internal */
export const ChangePrescriptionRequestBodyResourceScope$outboundSchema:
  z.ZodMiniEnum<typeof ChangePrescriptionRequestBodyResourceScope> = z.enum(
    ChangePrescriptionRequestBodyResourceScope,
  );

/** @internal */
export const ChangePrescriptionRequestBodyStartMode$outboundSchema:
  z.ZodMiniEnum<typeof ChangePrescriptionRequestBodyStartMode> = z.enum(
    ChangePrescriptionRequestBodyStartMode,
  );

/** @internal */
export type ChangePrescriptionRequestBody$Outbound = {
  expected_version: number;
  expires_at?: string | undefined;
  external_note: string;
  internal_note: string;
  operation_id: string;
  organization_id: string;
  prescription_id: string;
  resource_scope: string;
  selected_resource_inputs?: Array<string> | undefined;
  start_mode: string;
  starts_at?: string | undefined;
};

/** @internal */
export const ChangePrescriptionRequestBody$outboundSchema: z.ZodMiniType<
  ChangePrescriptionRequestBody$Outbound,
  ChangePrescriptionRequestBody
> = z.pipe(
  z.object({
    expectedVersion: z.int(),
    expiresAt: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    externalNote: z.string(),
    internalNote: z.string(),
    operationId: z.string(),
    organizationId: z.string(),
    prescriptionId: z.string(),
    resourceScope: ChangePrescriptionRequestBodyResourceScope$outboundSchema,
    selectedResourceInputs: z.optional(z.array(z.string())),
    startMode: ChangePrescriptionRequestBodyStartMode$outboundSchema,
    startsAt: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
  }),
  z.transform((v) => {
    return remap$(v, {
      expectedVersion: "expected_version",
      expiresAt: "expires_at",
      externalNote: "external_note",
      internalNote: "internal_note",
      operationId: "operation_id",
      organizationId: "organization_id",
      prescriptionId: "prescription_id",
      resourceScope: "resource_scope",
      selectedResourceInputs: "selected_resource_inputs",
      startMode: "start_mode",
      startsAt: "starts_at",
    });
  }),
);

export function changePrescriptionRequestBodyToJSON(
  changePrescriptionRequestBody: ChangePrescriptionRequestBody,
): string {
  return JSON.stringify(
    ChangePrescriptionRequestBody$outboundSchema.parse(
      changePrescriptionRequestBody,
    ),
  );
}
